"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyGenerateARandomVoiceV1VoiceGenerationGenerateVoicePostAge = void 0;
exports.BodyGenerateARandomVoiceV1VoiceGenerationGenerateVoicePostAge = {
    Young: "young",
    MiddleAged: "middle_aged",
    Old: "old",
};
